import axios from '../../../../utils/request';
function GET_LIST(params) {
    return axios.get("/admin/ALinks/index",{
        params: {
            page:params
        }
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/admin/ALinks/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.get("/admin/ALinks/edit",{
        params: {
            ...params
        }
    } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/admin/ALinks/editPost",{...params} )
}
function LIST_ORDER(params) {
    return  axios.post("/admin/ALinks/listOrder",{list_orders:params} )
}
function DELE(params) {
    return  axios.get("/admin/ALinks/delete",{
        params: {
            ids:params
        }
    } )
}

export default {
    GET_LIST,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    LIST_ORDER,
    DELE
};